import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { UseGetOrganisationQuestionsProps } from ".";

export function useGetOrganisationQuestions({ crm_id, organisation_id }: UseGetOrganisationQuestionsProps) {
    return useQuery({
        ...queryKeys.question_bank.list._ctx.byOrgId(organisation_id!)._ctx.byCrmId(crm_id!),
        enabled: !!organisation_id && !!crm_id,
    });
}
